import { ShippingAddressSelector as ShippingAddressSelectorShared } from '../../../../components/Containers/ReviewCheckoutDrawer/ShippingAddress/ShippingAddressSelector';
import { useFlow } from '../../../../providers';
import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';

export const ShippingAddressSelector = () => {
  const { addresses, selectedAddress, setSelectedAddress } =
    usePreAuthDrawCtx();

  const { goToStep } = useFlow();

  return (
    <ShippingAddressSelectorShared
      addresses={addresses}
      onUpdate={() => {
        goToStep('apply');
      }}
      selectedAddressId={selectedAddress}
      setSelectedAddressId={setSelectedAddress}
    />
  );
};
